const LoadAnchor = require('../../../requires/view/pc/ui/load-anchor');
const Anchor = require('../../../requires/view/pc/ui/anchor');
const Nav = require('../../../requires/view/pc/ui/nav');
const Parallax = require('../../../requires/view/pc/ui/parallax');
const parallaxOpts = require('../../../requires/view/pc/ui/parallax-option');
const ModalWinodw = require('../../../requires/view/pc/ui/modal-window');
require('html5-polyfills/classList');
require('html5-polyfills/dataset');
require('custom-event-polyfill');
require('../../../requires/polyfill/rAF');
require('lodash');
require('Velocity');

// create multiple incetance
const createIncetance = (_class, _selector, _opts) => {
  const $$el_ = document.querySelectorAll(_selector);
  const instances = [];
  for(let i_ = 0; $$el_.length > i_; i_++) {
    const arg_ = [ $$el_[i_] ];
    if(_opts) arg_.push(_opts);
    instances.push(new _class(...arg_));
  }
  return instances;
};

// create single incetance
const createSingleIncetance = (_class, _selector, _opts) => {
  const $$el_ = document.querySelectorAll(_selector);
  if(!$$el_.length) return false;
  const arg_ = [$$el_];
  if(_opts) arg_.push(_opts);
  return new _class(...arg_);
};

window.addEventListener('DOMContentLoaded', () => {

  const modules_ = [
    [ Nav, '.js-nav' ],
    [ Anchor, 'a', { offset: -120 } ],
  ];

  const singleModules_ = [
    [ Parallax, '.js-parallax', parallaxOpts ],
    [ ModalWinodw, '.js-mw' ],
  ];

  new LoadAnchor();

  modules_.forEach((_arr) => {
    createIncetance(..._arr);
  });

  singleModules_.forEach((_arr) => {
    createSingleIncetance(..._arr);
  });

});



/** WEBPACK FOOTER **
 ** ./webpack/src/championship2016/scripts/index.js
 **/